import React from 'react';
import './weekBooking.css';
import { useSelector } from "react-redux";
import BookingItem from "../BookingItem/BookingItem";

const WeekBooking = () => {
    const booking = useSelector(state => state.booking);

    return (
        <div className="page">
            <div className="week">
                <div className="week__days">
                    {
                        booking?.reserves.map(day => {
                            return (
                                <div className="week__day" key={ day.date }>
                                    <div className="week__header">
                                        <div className="week__date">{ day.date_formatted }</div>
                                        <div className="week__day-name">{ day.day }</div>
                                    </div>
                                    <div className="week__items">
                                        {
                                            day.booking.map(item => {
                                                return (
                                                    <BookingItem data={ item } key={ item.id } />
                                                );
                                            })
                                        }
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        </div>
    );
};

export default WeekBooking;